import React from 'react'
import { Modal } from 'react-bootstrap'

const AssemblySearchResultsModal = ({ isVisible, AssemblyProps, handleConfirm, onClose }) => {
    return (
        <Modal
            show={isVisible}
            backdropClassName='veil'
            animation={false}
            centered
            autoFocus={false}
            onHide={onClose}
        >
            <Modal.Header closeButton>
                <Modal.Title style={{ display: 'inline-block' }}>
                    We found this Assembly
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {AssemblyProps && (
                    <>
                        <table
                            style={{
                                width: '100%',
                                borderCollapse: 'separate',
                                borderSpacing: '0 10px',
                            }}
                        >
                            <tbody>
                                <tr>
                                    <td style={{ padding: '8px 16px', fontWeight: 'bold' }}>
                                        Awc ID
                                    </td>
                                    <td style={{ padding: '8px 16px' }}>
                                        {AssemblyProps.AWCAssemblyID}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ padding: '8px 16px', fontWeight: 'bold' }}>
                                        Customer Name
                                    </td>
                                    <td style={{ padding: '8px 16px' }}>
                                        {AssemblyProps.CustomerName}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ padding: '8px 16px', fontWeight: 'bold' }}>
                                        Serial Number
                                    </td>
                                    <td style={{ padding: '8px 16px' }}>
                                        {AssemblyProps.SerialNumber}
                                    </td>
                                </tr>
                                {/* <tr>
                                    <td style={{ padding: '8px 16px', fontWeight: 'bold' }}>
                                        Tag Number
                                    </td>
                                    <td style={{ padding: '8px 16px' }}>
                                        {AssemblyProps.TagNumber}
                                    </td>
                                </tr> */}
                            </tbody>
                        </table>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                marginTop: '10px',
                            }}
                        >
                            <button
                                className='btn btn-success'
                                onClick={() => {
                                    handleConfirm()
                                    onClose()
                                }}
                            >
                                Confirm
                            </button>
                        </div>
                    </>
                )}
            </Modal.Body>
        </Modal>
    )
}

export default AssemblySearchResultsModal
